import { z } from 'zod';

export const ProjectSchema = z.object({
  id: z.string().min(1),
  workspace_id: z.string().min(1),
  name: z.string().min(1),
  description: z.string().nullable(),
  created_at_ms: z.number().int().nonnegative(),
  updated_at_ms: z.number().int().nonnegative(),
  last_deployed_version: z.string().nullable(),
});

export const CreateProjectSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().optional(),
});

export const UpdateProjectSchema = z.object({
  name: z.string().min(1).optional(),
  description: z.string().optional(),
});

export type ParsedProject = z.infer<typeof ProjectSchema>;
export type ParsedCreateProject = z.infer<typeof CreateProjectSchema>;
export type ParsedUpdateProject = z.infer<typeof UpdateProjectSchema>;
